


export function setCookie(name, value, days = 30) {
    try {
        const expires = new Date();
        expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
        
        const data = {
            value: value,
            expires: expires.getTime(),
            shop: window.location.hostname // Ensures data is shop-specific
        };
        
        localStorage.setItem(`shopify_${name}`, JSON.stringify(data));
        return true;
    } catch (error) {
        console.error('Storage error:', error);
        return false;
    }
}

// Get data (replaces getCookie)
export function getCookie(name) {
    try {
        const stored = localStorage.getItem(`shopify_${name}`);
        if (!stored) return null;
        
        const data = JSON.parse(stored);
        
        // Check if expired
        if (Date.now() > data.expires) {
            localStorage.removeItem(`shopify_${name}`);
            return null;
        }
        
        // Check if same shop (security)
        if (data.shop !== window.location.hostname) {
            localStorage.removeItem(`shopify_${name}`);
            return null;
        }
        
        return data.value;
    } catch (error) {
        console.error('Storage error:', error);
        return null;
    }
}

// Remove data
export function removeData(name) {
    try {
        localStorage.removeItem(`shopify_${name}`);
        return true;
    } catch (error) {
        console.error('Storage error:', error);
        return false;
    }
}

// Check if data exists and is valid
export function hasData(name) {
    return getCookie(name) !== null;
}

// Clean up expired data (call this on app start)
export function cleanupExpiredData() {
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && key.startsWith('shopify_')) {
            try {
                const data = JSON.parse(localStorage.getItem(key));
                if (data.expires && Date.now() > data.expires) {
                    localStorage.removeItem(key);
                }
            } catch (error) {
                // Remove corrupted data
                localStorage.removeItem(key);
            }
        }
    }
}
